import cls from "classnames";
import React, { PureComponent } from "react";
import { POLLS_QUESTION_IMAGE, POLLS_QUESTION_TEXT_INPUT } from "../../data-hooks.js";
import { ImageUpload } from "../image-upload/image-upload.js";
import { withPoll } from "../poll-context/poll-context.js";
import { PollContextPropTypes } from "../poll-context/types.js";
import { RCEHelpersPropTypes, withRCEHelpers } from "../rce-helpers-context/index.js";
import { TextField } from "../text-field/text-field.js";
import styles from "./poll-header-scss.js";
class PollHeaderComponent extends PureComponent {
  render() {
    const { poll, changePollTitle, changePollImage, layout, t, rce } = this.props;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles.header, {
          [styles.webview]: rce.isWebView
        })
      },
      /* @__PURE__ */ React.createElement(
        TextField,
        {
          autofocus: true,
          textAutoResize: true,
          maxLength: 160,
          className: styles.title,
          value: poll.title,
          onChange: changePollTitle,
          placeholder: t("Poll_Editor_Question_Placeholder"),
          dataHook: POLLS_QUESTION_TEXT_INPUT
        }
      ),
      layout.poll?.enableImage && /* @__PURE__ */ React.createElement(
        ImageUpload,
        {
          dataHook: POLLS_QUESTION_IMAGE,
          disabled: rce.isPreview,
          className: styles.image,
          value: poll.image?.src?.url,
          onChange: changePollImage
        }
      )
    );
  }
}
const PollHeader = withRCEHelpers(withPoll(PollHeaderComponent));
PollHeaderComponent.propTypes = {
  ...PollContextPropTypes,
  ...RCEHelpersPropTypes
};
export {
  PollHeader
};
//# sourceMappingURL=poll-header.js.map
